import { defineComponent as B, ref as v, computed as w, onMounted as R, createBlock as h, createCommentVNode as y, openBlock as r, unref as s, withCtx as k, createElementVNode as c, normalizeStyle as x, createElementBlock as u, Fragment as D, renderList as T, normalizeClass as j, createTextVNode as g, toDisplayString as V, createVNode as q } from "vue";
import { ScalarTeleport as F, ScalarButton as G } from "@scalar/components";
import { ScalarIconGlobe as K, ScalarIconPlus as O } from "@scalar/icons";
import { onClickOutside as L } from "@vueuse/core";
import M from "fuse.js";
import { useRouter as Q } from "vue-router";
import { getEnvColor as W } from "../../libs/env-helpers.js";
import { PathId as _ } from "../../routes.js";
import { useActiveEntities as $ } from "../../store/active-entities.js";
import { parseEnvVariables as C } from "../../libs/environment-parser.js";
const H = {
  key: 0,
  class: "gap-1/2 flex flex-col"
}, J = ["onClick"], U = { class: "flex items-center gap-2 whitespace-nowrap" }, X = { class: "w-20 overflow-hidden text-right text-ellipsis whitespace-nowrap" }, de = /* @__PURE__ */ B({
  __name: "EnvironmentVariableDropdown",
  props: {
    query: {},
    environment: {},
    envVariables: {},
    dropdownPosition: {}
  },
  emits: ["select"],
  setup(S, { expose: E, emit: z }) {
    const a = S, I = z, d = v(!0), p = v(null), l = v(0), f = Q(), { activeCollection: m } = $(), N = () => {
      var n;
      if (!f)
        return;
      const { currentRoute: e, push: o } = f, t = e.value.params.workspace;
      !m.value || ((n = m.value.info) == null ? void 0 : n.title) === "Drafts" ? o({
        name: "environment.default",
        params: {
          [_.Workspace]: t
        }
      }) : o({
        name: "collection.environment",
        params: {
          [_.Collection]: m.value.uid
        }
      }), d.value = !1;
    }, P = new M(C(a.envVariables), {
      keys: ["key", "value"]
    }), i = w(() => {
      const e = a.query;
      if (!e)
        return C(a.envVariables).slice(-4).filter(({ key: t, value: n }) => t !== "" || n !== "");
      const o = P.search(e, { limit: 10 });
      return o.length > 0 ? o.map((t) => t.item).filter(({ key: t, value: n }) => t !== "" || n !== "") : [];
    }), b = (e) => {
      I("select", e);
    };
    E({
      handleArrowKey: (e) => {
        const o = e === "up" ? -1 : 1, t = i.value.length;
        t !== 0 && (l.value = (l.value + o + t) % t);
      },
      handleSelect: () => {
        if (l.value >= 0) {
          const e = i.value[l.value];
          e && b(e.key);
        }
      }
    }), R(() => {
      l.value = 0;
    });
    const A = w(() => {
      var e, o;
      return {
        left: (((e = a.dropdownPosition) == null ? void 0 : e.left) ?? 0) + "px",
        // Add a 5px offset from the editor
        top: (((o = a.dropdownPosition) == null ? void 0 : o.top) ?? 0) + 5 + "px"
      };
    });
    return L(
      p,
      () => {
        d.value = !1;
      },
      { ignore: [p] }
    ), (e, o) => d.value ? (r(), h(s(F), {
      key: 0,
      class: "scalar-client"
    }, {
      default: k(() => [
        c("div", {
          ref_key: "dropdownRef",
          ref: p,
          class: "custom-scroll fixed top-0 left-0 flex max-h-[60svh] w-56 flex-col rounded border p-0.75",
          style: x(A.value)
        }, [
          i.value.length ? (r(), u("ul", H, [
            (r(!0), u(D, null, T(i.value, (t, n) => (r(), u("li", {
              key: t.key,
              class: j(["font-code text-xxs hover:bg-b-2 flex h-8 cursor-pointer items-center justify-between gap-1.5 rounded p-1.5 transition-colors duration-150", { "bg-b-2": n === l.value }]),
              onClick: (ee) => b(t.key)
            }, [
              c("div", U, [
                t.source === "collection" && e.environment.name !== "No Environment" ? (r(), u("span", {
                  key: 0,
                  class: "h-2.25 w-2.25 min-w-2.25 rounded-full",
                  style: x({
                    backgroundColor: s(W)(e.environment)
                  })
                }, null, 4)) : (r(), h(s(K), {
                  key: 1,
                  class: "-ml-0.25 size-2.5",
                  icon: "Globe"
                })),
                g(" " + V(t.key), 1)
              ]),
              c("span", X, V(t.value), 1)
            ], 10, J))), 128))
          ])) : s(f) ? (r(), h(s(G), {
            key: 1,
            class: "font-code text-xxs bg-b-inherit hover:bg-b-2 flex h-8 w-full justify-start gap-2 px-1.5 transition-colors duration-150",
            variant: "outlined",
            onClick: N
          }, {
            default: k(() => [
              q(s(O), { class: "size-3" }),
              o[0] || (o[0] = g(" Add Variable "))
            ]),
            _: 1,
            __: [0]
          })) : y("", !0),
          o[1] || (o[1] = c("div", { class: "bg-b-1 brightness-lifted absolute inset-0 -z-1 rounded shadow-lg" }, null, -1))
        ], 4)
      ]),
      _: 1
    })) : y("", !0);
  }
});
export {
  de as default
};
